import { createSelector } from 'reselect';

export const getComponentState = state => state.personalLogin;

export const getIsLogging = createSelector(
    getComponentState,
    (state) => state.isLogging
);

export const getForm = createSelector(
    getComponentState,
    (state) => state.form
);

export const getRedirect = createSelector(
    getComponentState,
    (state) => state.redirect
);

export const getLoginType = createSelector(
    getComponentState,
    (state) => state.loginType
);

export const getIsSignUp = createSelector(
    getComponentState,
    (state) => state.isSignUp
);

export const getSigningUp = createSelector(
    getComponentState,
    (state) => state.signingUp
);

export const getSignUpType = createSelector(
    getComponentState,
    (state) => state.signUpType
);

export const getLoggedType = createSelector(
    getComponentState,
    (state) => state.loggedType
);